import React from 'react';
import styled from 'styled-components';

export const CancelLink: React.FC<{ navigate: F<string> }> = ({ navigate }) => (
  <Link onClick={() => navigate('cancel')}>Cancel your plan</Link>
);

const Link = styled.a`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  width: 8em;

  text-decoration-line: underline;

  color: #061e2d !important;
`;
